import type { Activity } from "@/api/types";

/** Which side of the conversation an interaction belongs to. */
export type Side = "them" | "us" | "both";

const norm = (v: string | null | undefined) => (v ?? "").trim().toLowerCase();

/** Their emails sit on the left; what we did (calls, our emails, notes) on the
 *  right; meetings and hospitality are shared, so they sit in the middle. */
export function sideOf(a: Activity, team: Set<string>): Side {
  if (a.type === "meeting" || a.type === "hospitality") return "both";
  if (a.type === "call" || a.type === "note") return "us";
  // Emails: whoever wrote it. Synced mail carries the sender's name or address.
  return team.has(norm(a.author)) ? "us" : "them";
}
